export default "__VITE_ASSET__CTflrZrL__"